module.exports = __webpack_public_path__ + "img/expert-4.c9fb9dd4.png";